import { render, staticRenderFns } from "./SignsDialog.vue?vue&type=template&id=0857ce93&scoped=true&"
import script from "./SignsDialog.vue?vue&type=script&lang=js&"
export * from "./SignsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SignsDialog.vue?vue&type=style&index=0&id=0857ce93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0857ce93",
  null
  
)

export default component.exports